import { render, staticRenderFns } from "./nearRelationPicture.vue?vue&type=template&id=34d07554"
import script from "./nearRelationPicture.vue?vue&type=script&lang=js"
export * from "./nearRelationPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d07554')) {
      api.createRecord('34d07554', component.options)
    } else {
      api.reload('34d07554', component.options)
    }
    module.hot.accept("./nearRelationPicture.vue?vue&type=template&id=34d07554", function () {
      api.rerender('34d07554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/near/nearRelationPicture.vue"
export default component.exports